var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLocation = function SvgLocation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53223 8.65932C3.54423 5.1255 6.41869 2.2705 9.95252 2.28251C13.4863 2.29451 16.3413 5.16898 16.3293 8.7028V8.77526C16.2858 11.0724 15.0032 13.1956 13.4308 14.855C12.5315 15.7888 11.5272 16.6156 10.438 17.3187C10.1468 17.5707 9.71478 17.5707 9.42353 17.3187C7.79978 16.2619 6.37467 14.9275 5.21339 13.3767C4.17835 12.0244 3.5907 10.383 3.53223 8.68106L3.53223 8.65932Z",
    stroke: "#9499B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.93061,
    cy: 8.78241,
    r: 2.05072,
    stroke: "#9499B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLocation);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjUzMjIzIDguNjU5MzJDMy41NDQyMyA1LjEyNTUgNi40MTg2OSAyLjI3MDUgOS45NTI1MiAyLjI4MjUxQzEzLjQ4NjMgMi4yOTQ1MSAxNi4zNDEzIDUuMTY4OTggMTYuMzI5MyA4LjcwMjhWOC43NzUyNkMxNi4yODU4IDExLjA3MjQgMTUuMDAzMiAxMy4xOTU2IDEzLjQzMDggMTQuODU1QzEyLjUzMTUgMTUuNzg4OCAxMS41MjcyIDE2LjYxNTYgMTAuNDM4IDE3LjMxODdDMTAuMTQ2OCAxNy41NzA3IDkuNzE0NzggMTcuNTcwNyA5LjQyMzUzIDE3LjMxODdDNy43OTk3OCAxNi4yNjE5IDYuMzc0NjcgMTQuOTI3NSA1LjIxMzM5IDEzLjM3NjdDNC4xNzgzNSAxMi4wMjQ0IDMuNTkwNyAxMC4zODMgMy41MzIyMyA4LjY4MTA2TDMuNTMyMjMgOC42NTkzMloiIHN0cm9rZT0iIzk0OTlCNSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8Y2lyY2xlIGN4PSI5LjkzMDYxIiBjeT0iOC43ODI0MSIgcj0iMi4wNTA3MiIgc3Ryb2tlPSIjOTQ5OUI1IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";